import moment from "@baserow/modules/core/moment";

export function scheduleParts(value, timezone) {
  if (value?._draft) return value._draft;
  if (value?.all_day) {
    return { date: value.start, startTime: "", endTime: "" };
  }
  if (!value?.start || !value?.end) {
    return { date: "", startTime: "", endTime: "" };
  }

  const start = moment(value.start).tz(timezone);
  const end = moment(value.end).tz(timezone);
  return {
    date: start.format("YYYY-MM-DD"),
    startTime: start.format("HH:mm"),
    endTime: end.format("HH:mm"),
  };
}

export function scheduleFromParts(parts, timezone) {
  if (!parts.date && !parts.startTime && !parts.endTime) return null;
  if (parts.date && !parts.startTime && !parts.endTime) {
    const date = moment.utc(parts.date, "YYYY-MM-DD", true);
    if (!date.isValid()) {
      return { start: null, end: null, _draft: { ...parts } };
    }
    return {
      start: date.format("YYYY-MM-DD"),
      end: date.clone().add(1, "day").format("YYYY-MM-DD"),
      all_day: true,
    };
  }
  if (!parts.date || !parts.startTime || !parts.endTime) {
    return { start: null, end: null, _draft: { ...parts } };
  }

  const start = moment.tz(
    `${parts.date} ${parts.startTime}`,
    "YYYY-MM-DD HH:mm",
    true,
    timezone,
  );
  const end = moment.tz(
    `${parts.date} ${parts.endTime}`,
    "YYYY-MM-DD HH:mm",
    true,
    timezone,
  );
  if (!start.isValid() || !end.isValid()) {
    return { start: null, end: null, _draft: { ...parts } };
  }
  return { start: start.format(), end: end.format() };
}

export function scheduleError(value, timezone) {
  if (value == null) return null;
  if (value.all_day === true) {
    const start = moment.utc(value.start, "YYYY-MM-DD", true);
    const end = moment.utc(value.end, "YYYY-MM-DD", true);
    if (!start.isValid() || !end.isValid()) return "Enter a valid date.";
    if (!end.isSame(start.clone().add(1, "day"))) {
      return "An all-day schedule must cover one day.";
    }
    return null;
  }
  if (!value.start || !value.end) {
    return "Choose a date, start time, and end time.";
  }

  const start = moment(value.start).tz(timezone);
  const end = moment(value.end).tz(timezone);
  if (!start.isValid() || !end.isValid()) {
    return "Enter a valid date and time.";
  }
  if (start.format("YYYY-MM-DD") !== end.format("YYYY-MM-DD")) {
    return "The schedule cannot cross midnight.";
  }
  if (!end.isAfter(start)) return "End time must be later than start time.";
  return null;
}

export function formatSchedule(value, timezone) {
  if (value == null || scheduleError(value, timezone) !== null) return "";
  if (value.all_day === true) return formatScheduleDate(value, timezone);
  return `${formatScheduleDate(value, timezone)} · ${formatScheduleTime(
    value,
    timezone,
  )}`;
}

export function formatScheduleDate(value, timezone) {
  if (value.all_day === true) {
    return moment.utc(value.start, "YYYY-MM-DD", true).format("MM/DD/YYYY");
  }
  return moment(value.start).tz(timezone).format("MM/DD/YYYY");
}

export function formatScheduleTime(value, timezone) {
  if (value.all_day === true) return "";
  const start = moment(value.start).tz(timezone);
  const end = moment(value.end).tz(timezone);
  return `${start.format("h:mm A")} – ${end.format("h:mm A")}`;
}
